import React,{ useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import {
    useGetAllCountriesQuery,
    useGetCaCategoriesQuery,
    useGetCaRolesQuery,      
} from '../../../pages/correctiveActions/correctiveActionsSlice'
import { Country,Category,Role } from '../type'

interface CaSearchFilterPropTypes {
    selectedCountry:Country,
    selectedCategory:Category,
    selectedRole:Role,   
    filterDisable:boolean
    setSelectedCountry?: (e: Country) => void;
    setSelectedCategory?: (e: Category) => void;
    setSelectedRole?: (e: Role) => void;
}

export const CaSearchFilter = ({    
    selectedCountry,
    selectedCategory,
    selectedRole, 
    setSelectedCountry,
    setSelectedCategory,
    setSelectedRole,
    filterDisable,  

}: CaSearchFilterPropTypes) => {

    const { data: allCountries } = useGetAllCountriesQuery();
    const { data: allCategories } = useGetCaCategoriesQuery();
    const { data: allRoles } = useGetCaRolesQuery();

    useEffect(() => {
        const country = JSON.parse(localStorage.getItem('country') || '{}');
        const category = JSON.parse(localStorage.getItem('category') || '{}');
        const role = JSON.parse(localStorage.getItem('role') || '{}');
        if (setSelectedCountry !== undefined)
            setSelectedCountry(country);
        if (setSelectedCategory !== undefined)
            setSelectedCategory(category);
        if (setSelectedRole !== undefined)
            setSelectedRole(role);
    }, []);

    const handleOnCountryChange = (e: any) => {
        const selectedText = allCountries?.data?.find((country: any) => country.country_id === e.target.value);
        if (selectedText !== undefined && setSelectedCountry !== undefined) {
            setSelectedCountry(selectedText);
            window.localStorage.country = JSON.stringify(selectedText);
        }
    }
    const handleOnRoleChange = (e: any) => {
        const selectedText = allRoles?.data?.find((role: any) => role.scorecard_role_id === e.target.value);      
        if (selectedText !== undefined && setSelectedRole !== undefined) {
            setSelectedRole(selectedText);
            window.localStorage.role =  JSON.stringify(selectedText);
        }
    }

    const handleOnCategoryChange = (e: any) => {
        const selectedText = allCategories?.data?.find((category: any) => category.ca_category_id === e.target.value);
        if (selectedText !== undefined && setSelectedCategory !== undefined) {
            setSelectedCategory(selectedText);
            window.localStorage.category =  JSON.stringify(selectedText);
        }
    }

    return (
        <div className='row'>
            <div className='col-md-3' >
                <div className='content'>
                    <label htmlFor="countrydd">Country</label>
                    <Dropdown
                        id='countrydd'
                        disabled={filterDisable}
                        placeholder="Select a Country"
                        className="custom-dropdown"
                        options={allCountries?.data}
                        optionValue={'country_id'}
                        optionLabel={'country_name'}
                        value={selectedCountry?.country_id}
                        onChange={handleOnCountryChange}
                    />
                </div>
            </div>
            <div className='col-md-3'>
                <div className='content'>
                    <label htmlFor="categorydd">Category</label>
                    <Dropdown
                        disabled={filterDisable}
                        id='categorydd'
                        placeholder="Select a Category"
                        className="custom-dropdown"
                        options={allCategories?.data}
                        optionValue={'ca_category_id'}
                        optionLabel={'ca_category_name'}                       
                        value={selectedCategory?.ca_category_id}
                        onChange={handleOnCategoryChange}
                    />
                </div>
            </div>
            <div className='col-md-3'>
                <div className='content'>
                    <label htmlFor="Roledd">Role</label>
                    <Dropdown
                        disabled={filterDisable}
                        id='Roledd'
                        placeholder="Select a Role"
                        className="custom-dropdown"
                        options={allRoles?.data}
                        optionValue={'scorecard_role_id'}
                        optionLabel={'scorecard_role_name'}                        
                        value={selectedRole?.scorecard_role_id}
                        onChange={handleOnRoleChange}
                    />
                </div>
            </div>
            <div className='col-md-3'>&nbsp;</div>
        </div>
    )
};